import React, { useState } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, Button, ButtonProps } from "@mui/material";
import s from "./styles.module.css";

interface IProps {
  children: React.ReactNode;
  buttonText: string;
  buttonProps?: ButtonProps;
}
const CollapseWithControls: React.FC<IProps> = ({ children, buttonText, buttonProps }) => {
  const [open, setOpen] = useState(false);
  const handleExpand = () => setOpen(!open);

  return (
    <>
      <div className={s.expandButton}>
        <Button size="small" onClick={handleExpand} {...buttonProps}>
          {buttonText}
          {open ? (
            <ExpandLess className={s.hover} />
          ) : (
            <ExpandMore className={s.hover} data-test="expand-notes" />
          )}
        </Button>
      </div>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
};

export default CollapseWithControls;
